import React from 'react';
import {Link} from 'react-router';
import { Collapse } from "@blueprintjs/core";
import {Legend, Tooltip, ResponsiveContainer, PieChart, Pie, Cell} from 'recharts';
import { DropDownChonLoaiDonThu } from 'components/tt-forms';
import { ShowIf } from 'components/utils';

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
  return `${(percent * 100).toFixed(0)}%`;
};

class CircleChart extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state ={
      isOpen: true,
      dataColor: [
        {color: '#fd9c35'},
        {color: '#fec42c'},
        {color: '#5578c2'},
        {color: '#5793f3'},
        {color: '#37c93c'},
        {color: '#ff0000'},
        {color: '#ffff00'},
        {color: '#00ffff'},
        {color: '#bf00ff'},
        {color: '#bfff00'}
      ],
      data: this.props.data,
      loaiLinhVucDon: this.props.loaiLinhVucDon,
      title: this.props.title,
      hasDropDown: this.props.hasDropDown
    }
  }

  handleCollapse() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      hasDropDown: nextProps.hasDropDown,
      title: nextProps.title,
      data: nextProps.data,
      loaiLinhVucDon: nextProps.loaiLinhVucDon
    })
  }

  onChange(e) {
    this.setState({
      loaiLinhVucDon: e.target.value
    });
    this.props.onChange(e);
  }

  render() {
    return (
      <section className="wrap-collapse col-6">
        <div className="wrap-shadow">
          <h2 className={this.state.isOpen ? "collapse-title collapse-open" : "collapse-title collapse-close"}><Link onClick={this.handleCollapse.bind(this)}>{this.state.title}</Link></h2>
          <Collapse className="letter-count-wrap" isOpen={this.state.isOpen}>
            <ShowIf condition={this.state.hasDropDown}>
              <DropDownChonLoaiDonThu page={this.props.page} label={null} selectedValue={this.state.loaiLinhVucDon} placeholder={null} className="input-20 dropdown-collapses" onChange={this.onChange.bind(this)}/>
            </ShowIf>
            <ShowIf condition={this.state.data.length > 0}>
              <ResponsiveContainer width="100%" height={400}>
                <PieChart>
                  <Legend iconType='circle' iconSize={10} margin={{top: 40}}/>
                  <Tooltip/>
                  <Pie
                    data={this.state.data}
                    dataKey="value"
                    nameKey="name"
                    startAngle={90}
                    endAngle={450}
                    innerRadius={50}
                    labelLine={true}
                    label={renderCustomizedLabel}
                    fill="#82ca9d">
                    {
                    	this.state.data.map((entry, index) => {
                        return <Cell key={index} fill={this.state.dataColor[index].color}/>
                      })
                    }

                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </ShowIf>
            <ShowIf condition={this.state.data.length == 0 }>
              <div className="pl15 pt35 pr15 pb45 txt-center">
                <i className="text-13">Chưa có dữ liệu</i>
              </div>
            </ShowIf>
          </Collapse>
        </div>
      </section>
    );
  }
}

CircleChart.defaultProps = {
  title: '',
  hasDropDown: false,
  loaiDon: 'DON_KHIEU_NAI',
  data: []
}

export default CircleChart;



// WEBPACK FOOTER //
// ./src/components/modules/home/CircleChart.jsx